<template>
  <base-create-form
    :create-form="createForm"
    :formTitle="formTitle"
    @submitForm="submitForm"
    @cancel="cancel"
  ></base-create-form>
</template>

<script>
import { BaseCreateForm } from "@/components/Base/index.js";
import sanitizer from "sanitizer";
import { ProgramCriterionCategoriesService } from "../../../services/programCriterionCategories.service";
export default {
  name: "ProgramCriterionCategoryCreateForm",
  components: { BaseCreateForm },
  data() {
    return {
      formTitle: this.$t("page_title.program_criterion_category_create"),
      createForm: [
        {
          label: this.$t("program_criterion_category.name"),
          name: "name",
          value: "",
          type: "input",
          required: true,
          validateRule: "required"
        },
        {
          label: this.$t("program_criterion_category.description"),
          name: "description",
          value: "",
          type: "textarea",
          required: false,
          validateRule: ""
        }
      ]
    };
  },
  methods: {
    cancel() {
      this.$router.push({ name: "ProgramCriterionCategoryList" });
    },
    async submitForm(params) {
      const response = await new ProgramCriterionCategoriesService().create(
        params
      );
      if (!response) return;
      this.$notify({
        title: this.$t("program_criterion_category.created"),
        text: this.$t("program_criterion_category.created_text", {
          name: sanitizer.escape(response.name)
        }),
        type: "success"
      });
      setTimeout(
        () => this.$router.push({ name: "ProgramCriterionCategoryList" }),
        500
      );
    }
  }
};
</script>

<style scoped></style>
